import { MemberSettings } from "@types";
import usePreference from "./usePreference";

export const useMemberSettings = (): MemberSettings => {
  const { memberSettings } = usePreference();
  return memberSettings;
};
